"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForEvent = void 0;
const withTimeout_1 = require("./withTimeout");
/**
 * Wait for an event to be emitted on emitter within timeout.
 *
 * @param emitter emitter of event
 * @param eventName event to wait for
 * @param timeout amount of time in milliseconds to wait for
 * @param predicate function that gets passed the event arguments, should return true if event accepted
 * @param abortController
 * @returns {Promise<unknown[]>} resolves with event arguments if event occurred within timeout else rejects
 */
async function waitForEvent(emitter, eventName, timeout = 5000, predicate = () => true, abortController) {
    let listener;
    // eslint-disable-next-line no-async-promise-executor
    const task = new Promise((resolve) => {
        listener = (...eventArgs) => {
            if (predicate(...eventArgs)) {
                resolve(eventArgs);
            }
        };
        emitter.on(eventName, listener);
    });
    return (0, withTimeout_1.withTimeout)(task, timeout, 'waitForEvent', abortController).finally(() => {
        emitter.off(eventName, listener);
    });
}
exports.waitForEvent = waitForEvent;
//# sourceMappingURL=waitForEvent.js.map